import { Logger as LoggerInstance } from './logger';
import { createRegistry } from './registry';

// Export Logger type for external use
export type { Logger } from './logger';

// Re-exported from './redaction' rather than './impl/pino' on purpose: the
// pino module builds a logger when it is evaluated, and the registry below
// imports it lazily. Going through the data-only module keeps that lazy.
export { SENSITIVE_FIELDS } from './redaction';

// Define the type for the logger provider.  Currently supporting 'pino'.
type LoggerProvider = 'pino' | 'console';

// Use pino as the default logger provider
const LOGGER = (process.env.LOGGER ?? 'pino') as LoggerProvider;

// Create a registry for logger implementations
const loggerRegistry = createRegistry<LoggerInstance, LoggerProvider>();

// Register the 'pino' logger implementation
loggerRegistry.register('pino', async () => {
  const { Logger: PinoLogger } = await import('./impl/pino');

  return PinoLogger;
});

// Register the 'console' logger implementation
loggerRegistry.register('console', async () => {
  const { Logger: ConsoleLogger } = await import('./impl/console');

  return ConsoleLogger;
});

/**
 * @name getLogger
 * @description Retrieves the logger implementation based on the LOGGER environment variable using the registry API.
 */
export async function getLogger() {
  return loggerRegistry.get(LOGGER);
}
